import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-4dd5201f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "num-statistics-warp"
};
const _hoisted_2 = {
  class: "top-count-statistics cms-card-block"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = {
  class: "title-name"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_7 = {
  class: "total-count text-center"
};
const _hoisted_8 = {
  class: "total-item-warp"
};
const _hoisted_9 = {
  class: "total-item"
};
const _hoisted_10 = {
  class: "header"
};
const _hoisted_11 = {
  class: "count"
};
const _hoisted_12 = {
  class: "total-item"
};
const _hoisted_13 = {
  class: "header"
};
const _hoisted_14 = {
  class: "count"
};
const _hoisted_15 = {
  class: "total-item"
};
const _hoisted_16 = {
  class: "header"
};
const _hoisted_17 = {
  class: "count"
};
const _hoisted_18 = {
  class: "bottom-count-statistics cms-card-block mg-b--15"
};
const _hoisted_19 = {
  class: "title"
};
const _hoisted_20 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_21 = {
  class: "title-name"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_23 = {
  class: "info"
};
const _hoisted_24 = {
  class: "day-count"
};
const _hoisted_25 = {
  class: "item-count"
};
const _hoisted_26 = {
  class: "header"
};
const _hoisted_27 = {
  class: "count"
};
const _hoisted_28 = {
  class: "item-count"
};
const _hoisted_29 = {
  class: "header"
};
const _hoisted_30 = {
  class: "count"
};
const _hoisted_31 = {
  class: "month-count"
};
const _hoisted_32 = {
  class: "item-count"
};
const _hoisted_33 = {
  class: "header"
};
const _hoisted_34 = {
  class: "count"
};
const _hoisted_35 = {
  class: "item-count"
};
const _hoisted_36 = {
  class: "header"
};
const _hoisted_37 = {
  class: "count"
};
const _hoisted_38 = {
  class: "bottom-count-statistics cms-card-block mg-b--0"
};
const _hoisted_39 = {
  class: "title"
};
const _hoisted_40 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_41 = {
  class: "title-name"
};

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_43 = {
  class: "info"
};
const _hoisted_44 = {
  class: "all-count"
};
const _hoisted_45 = {
  class: "item-count"
};
const _hoisted_46 = {
  class: "header"
};
const _hoisted_47 = {
  class: "count"
};
const _hoisted_48 = {
  class: "item-count"
};
const _hoisted_49 = {
  class: "header"
};
const _hoisted_50 = {
  class: "count"
};
import { inject } from 'vue';
import { getTextWidth } from '@/utils';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'NumStatistics',
  props: {
    title: {
      type: String,
      default: ''
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const tooltipContent = ref(t('(电影总数 + 电视剧剧集总数)'));
    const optionTooltipContent = ref(t('为节目被操作的次数，例如节目被操作2次上线，数据即为2。'));
    const countTooltipContent = ref(t('为节目在平台上数据，以节目最终状态为统计结果，例如节目操作上线再操作下线，那么上线-1，下线+1。')); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = (e, fontSize) => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: fontSize,
        fontWeight: 600
      });
      tipDisabled.value = target.offsetWidth > width;
    };

    const numStatisticsObj = inject('numStatisticsObj'); // console.log('numStatisticsObj', numStatisticsObj);

    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('影片总数')), 1), _createVNode(_component_el_tooltip, {
        "popper-class": "self-popper",
        content: tooltipContent.value,
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(numStatisticsObj).videoCountObj.total || 0), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('电影总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[0] || (_cache[0] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('电影总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(numStatisticsObj).videoCountObj.movieCount || 0), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('电视剧总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[1] || (_cache[1] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('电视剧总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(numStatisticsObj).videoCountObj.seriesCount || 0), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('电视剧剧集总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[2] || (_cache[2] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('电视剧剧集总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(numStatisticsObj).videoCountObj.episodeCount || 0), 1)])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t(__props.title + '操作统计')), 1), _createVNode(_component_el_tooltip, {
        "popper-class": "self-popper",
        content: optionTooltipContent.value,
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_hoisted_22]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('昨日上线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[3] || (_cache[3] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('昨日上线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.yesterdayOnlineCount || 0), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('昨日下线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[4] || (_cache[4] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('昨日下线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.yesterdayOfflineCount || 0), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('本月上线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[5] || (_cache[5] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('本月上线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.monthOnlineCount || 0), 1)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('本月下线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[6] || (_cache[6] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('本月下线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.monthOfflineCount || 0), 1)])])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t(__props.title + '节目统计')), 1), _createVNode(_component_el_tooltip, {
        "popper-class": "self-popper",
        content: countTooltipContent.value,
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_hoisted_42]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('上线节目总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[7] || (_cache[7] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('上线节目总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.onlineCount || 0), 1)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('下线节目总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[8] || (_cache[8] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('下线节目总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(numStatisticsObj).onlineOfflineCountObj.offlineCount || 0), 1)])])])])]);
    };
  }

});